import React from "react";
import { BsPersonPlusFill } from "react-icons/all";
import { useColorModeValue } from "@chakra-ui/react";

import { useGetThemeColors } from "ChakraTheme";
import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { Button, IButtonProps } from "components/Button";

interface IProps extends Omit<IButtonProps, "id"> {
  openRegisterModal: () => void;
}

const RegisterButton = ({ openRegisterModal, ...restProps }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.white, colors.black);
  const textColor = useColorModeValue(colors.white, colors.black);

  const backgroundBtnColor = useColorModeValue(
    colors.yellow[700],
    colors.yellow[200]
  );
  const hoverBackgroundBtnColor = useColorModeValue(
    colors.yellow[600],
    colors.yellow[400]
  );
  const activeBackgroundBtnColor = useColorModeValue(
    colors.yellow[500],
    colors.yellow[500]
  );

  return (
    <Button
      bg={backgroundBtnColor}
      _hover={{
        bg: hoverBackgroundBtnColor,
      }}
      _active={{
        bg: activeBackgroundBtnColor,
      }}
      minW="auto"
      h="35px"
      borderRadius={8}
      px={5}
      leftIcon={<Icon color={iconColor} icon={BsPersonPlusFill} />}
      color={textColor}
      onClick={openRegisterModal}
      fontSize="lg"
      id="register-btn"
      {...restProps}
    >
      <ChakraText fontSize={restProps.fontSize}>Rejestracja</ChakraText>
    </Button>
  );
};

export { RegisterButton };
